import React, { useCallback, useState } from 'react';

import { Link, Typography } from '@mui/material';

import { PromotionRoomScope, getPromotionRoomScopeDisplay } from '~/utils/promotionRoomScope';
import { pluralizeToString } from '~/utils/stringUtils';

import PromotionRoomsModal from './PromotionRoomsModal';

type Props = {
  promotion: PromotionRoomScope;
  ratePlanRooms: Array<{ id: string; name: string }>;
};

export default function PromotionRoomScopeCell({ promotion, ratePlanRooms }: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  const scopeDisplay = getPromotionRoomScopeDisplay(promotion, ratePlanRooms);

  if (scopeDisplay.kind === 'rate-plan') {
    return <Typography variant="body2">All rooms on this rate</Typography>;
  }

  if (scopeDisplay.kind === 'no-rooms') {
    return (
      <Typography variant="body2" color="error">
        No rooms - not applied
      </Typography>
    );
  }

  if (scopeDisplay.kind === 'room-count') {
    return <Typography variant="body2">{pluralizeToString('room', scopeDisplay.roomCount)}</Typography>;
  }

  return (
    <>
      <Link component="button" variant="body2" onClick={openModal}>
        {pluralizeToString('room', scopeDisplay.roomNames.length)}
      </Link>
      <PromotionRoomsModal open={isModalOpen} onClose={closeModal} roomNames={scopeDisplay.roomNames} />
    </>
  );
}
